<template>
    <div class="select">
        <select name="sort" id="sort" @change="$emit('on-sort-changed')">
            <option value="">Vybrať</option>
            <option value="new-desc">Najnovšie</option>
            <option value="price-asc">Najlacnejšie</option>
            <option value="price-desc">Najdrahšie</option>
        </select>
    </div>
</template>

<script>
import { inject, onMounted, ref } from 'vue'

import { setSelectOption } from '../../functions/helpers'

export default {

    props: {
        productsCount: {
            required: false,
            type: Number
        }
    },

    emits: ['on-sort-changed'],

    setup() {

        const emitter = inject('emitter')

        onMounted( () => {
            emitter.on('set-values-from-parameters', ({ sort }) => {
                if ( sort && sort.length ) setSelectOption('#sort', sort)
            })
        })
    }
}
</script>
